/* eslint-disable eqeqeq */
import { useState } from "react";
import { LiButton } from "../../../../Utils/CustomComponent";
import { conversationFormInputArr } from "./ConversationConstant";
import FormBox from "../../../FormBox/FormBox";

const Conversations = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
              <a href="/submit-a-loan" style={{ textDecoration: "none" }}>
                Conversations
              </a>{" "}
              / Form
            </h6>
          </div>
        </article>
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">Conversations Form</h4>
            <div className="loan-details">
              <div className="pt-5 mt-5">
                <ul className="nav nav-tabs row">
                  {tabButtons?.map((data, index) => (
                    <LiButton
                      key={index}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      label={data.label}
                      value={index}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <div className="loans-in-details mt-5">
              {conversationFormInputArr?.map((data, index) => {
                return activeTab == index ? (
                  <FormBox key={index} InputBoxArr={data.arr} />
                ) : null;
              })}
            </div>
          </section>
        </article>
      </section>
    </div>
  );
};
export default Conversations;
let tabButtons = [
  {
    label: <p className="p-0 m-0">Default Info</p>,
  },
  {
    label: <p className="p-0 m-0">3rd Party Auth</p>,
  },
  {
    label: <p className="p-0 m-0">Bankruptcy</p>,
  },
  {
    label: <p className="p-0 m-0">Deliquent Tax Info</p>,
  },
  {
    label: <p className="p-0 m-0">Hazard Insurance</p>,
  },
  {
    label: <p className="p-0 m-0">Senior Lien Default</p>,
  },
  {
    label: <p className="p-0 m-0">Lis pendens</p>,
  },
  {
    label: <p className="p-0 m-0">Lien Release Info</p>,
  },
  {
    label: <p className="p-0 m-0">ID</p>,
  },
  {
    label: <p className="p-0 m-0">Maturity-Pymt Ovrde</p>,
  },
  {
    label: <p className="p-0 m-0">CSP-Data Fields</p>,
  },
];
